// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"8811152a","129":"b8fe44db","131":"b13afd81","384":"ff9c4e0a","532":"4d08b510","674":"2b0032ab","681":"7dfd68fb","787":"cda612ba","884":"61f25243","965":"3e4320b5","966":"aad98ebf"}[chunkId] + ".chunk.js";
};